var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');
var slugify = require('../helpers/slugify');
var _ = require('underscore');

// Job Area
module.exports = React.createClass({

	// Render
  	render: function(){
  		
  		var title = this.props.title;
  		  	title = title.replace('&amp;', '&');
  		  	title = title.replace('&amp;', '&');
  		  	
  		var job_url = '/'+this.props.env+'/'+this.props.job_id+'/'+slugify(this.props.title);
  		
  		var logo = (this.props.company_logo != '') ? (<img src={this.props.company_logo} />) : '';
  		
  		var style = {};
  		
  		if(!_.isUndefined(this.props.job.publish_picture) && this.props.job.publish_picture !== ''){
	  		logo = (<img src={this.props.job.publish_picture} />);
  		}
  		
  		if(logo == ''){
	  		logo = (<img src={this.props.env_info.logo} />);
  		}
  		
  		if(this.props.env_info.name === 'vel'){
	  		logo = '';
  		}
  		
  		if(this.props.env_info.settings.hide_header){
	  		logo = '';
	  		style.margin = '0px';
	  		style.padding = '0px';
	  		style.display = 'none';
  		}
  		
   		return (
   			<div className="job-header" style={style}>
   				{logo}
      			<h1><a href={job_url}>{title}</a></h1>
	  		</div>
	  	);
	}
});
